import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, TextInput } from '../../types'
import { CmsConverterService, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class HandBookTableOfContentConverter extends CmsConverterService<HandBookTableOfContentData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      textIntro: formData.st_text ?? defaultTextInput
    }
  }
}

export const HANDBOOK_TABLE_OF_CONTENT_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, HandBookTableOfContentData>>('HandBookTableOfContentConverter')

export interface HandBookTableOfContentData extends ConvertedComponentData {
  textIntro: TextInput;
}

export interface TableOfContentDTO {
  id: string;
  label: string;
  url: string;
  collapsed?: boolean;
  children?: TableOfContentDTO[];
}
